


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation, Action } from 'vuex-class';

import { Button } from '@/components/core';
import Track from '@/components/track.vue';
import { promisify } from '@/utils';
import { setTimeout } from 'timers';

@Component({
  components: { Button, Track },
})
export default class Playlist extends Vue {
  @Prop({ default: () => ({}) }) private model: IPlaylistData;
  @Prop({ default: () => ({}) }) private mods!: Hash;

  @State('player') private player: IPlayerData;

  private blockName: string = 'playlist';

  @Getter('Player::currentTrack') private currentTrack: ITrackData;

  private get tracks() {
    if (this.model.trackList.first == null) return [];
    let node = this.model.trackList.first;
    const res = [node];
    while (node.next != null) {
      res.push(node.next);
      node = node.next;
    }
    return res;
  }

  get count() {
    if (this.model == null) return 0;
    return this.model.count;
  }

  get duration() {
    if (this.model == null) return 0;
    return this.model.duration;
  }

  get size() {
    if (this.model == null) return 0;
    return this.model.size;
  }

  @Action('createTrack') private createTrack: MutationMethod;
  @Mutation('addTracksToPlaylist') private addTracksToPlaylist: MutationMethod;
  @Mutation('removeTracksFromPlaylist') private removeTracksFromPlaylist: MutationMethod;
  @Mutation('updateCursor') private updateCursor: MutationMethod;
  @Mutation('updateActivePlaylist') private updateActivePlaylist: MutationMethod;

  private async load() {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'audio/*';
    const handler = async (event: Event) => {
      input.removeEventListener('change', handler);
      const tracks = [];
      for (const file of Array.from((event.target as HTMLInputElement).files)) {
        tracks.push(await promisify(this.createTrack, { file }));
      }
      this.addTracksToPlaylist({ id: this.model.id, tracks });
    };
    input.addEventListener('change', handler);
    input.click();
  }

  private selectTrack(node: ITrackNode) {
    if (
      this.player.activePlaylist != null &&
      this.player.activePlaylist.id !== this.model.id
    ) this.updateActivePlaylist(this.model);
    this.updateCursor({id: this.model.id, node});
  }

  private removeTrack(node: ITrackNode) {
    this.removeTracksFromPlaylist({id: this.model.id, node});
  }

  private trackListDragEnter(event: DragEvent) {
    this.$el.querySelector('.playlist__track-list').classList.add('playlist__track-list--drag-ready');
  }

  private trackListDragLeave(event: DragEvent) {
    // console.log(this.$el.querySelector('.playlist__track-list').contains((event.target as HTMLElement)),
    // this.$el.querySelector('.playlist__track-list') === event.target)
    // if (this.$el.querySelector('.playlist__track-list').contains((event.target as HTMLElement))) return;
    this.$el.querySelector('.playlist__track-list').classList.remove('playlist__track-list--drag-ready');
  }

  private trackListDragOver(event: DragEvent) {
    // Do nothing
  }

  private trackListDragEnd(event: DragEvent) {
    this.$el.querySelector('.playlist__track-list').classList.remove('playlist__track-list--drag-ready');
  }

  private async trackListDrop(event: DragEvent) {
    this.$el.querySelector('.playlist__track-list').classList.remove('playlist__track-list--drag-ready');
    const tracks = [];
    for (const file of Array.from(event.dataTransfer.files)) {
      if (/^audio\/.*$/ig.test(file.type))
        tracks.push(await promisify(this.createTrack, { file }));
    }
    this.addTracksToPlaylist({ id: this.model.id, tracks });
  }
}
